import { useCallback, useState } from 'react'

import { SortOrder, TicketsRequestSortBy } from 'types'

type Value = `${TicketsRequestSortBy}:${SortOrder}`
const sortingOptions: {
  value: Value
  label: string
  key: string
}[] = [
  {
    key: 'longestWait',
    value: `${TicketsRequestSortBy.WaitTime}:${SortOrder.Desc}`,
    label: 'Longest wait',
  },
  {
    key: 'shortestWait',
    value: `${TicketsRequestSortBy.WaitTime}:${SortOrder.Asc}`,
    label: 'Shortest wait',
  },
  {
    key: 'newest',
    value: `${TicketsRequestSortBy.CreationDate}:${SortOrder.Desc}`,
    label: 'Newest',
  },
  {
    key: 'oldest',
    value: `${TicketsRequestSortBy.CreationDate}:${SortOrder.Asc}`,
    label: 'Oldest',
  },
]
export const useTicketsSorting = () => {
  const [activeSorting, setActiveSorting] = useState<Value>(sortingOptions[0].value)
  const [sortBy, sortOrder] = activeSorting.split(':')

  const handleSortingSelect = useCallback(
    (value: string) => setActiveSorting(value as Value),
    [],
  )
  const handleSortingRest = useCallback(
    () => setActiveSorting(sortingOptions[0].value),
    [],
  )

  return {
    sortingOptions,
    sortingValue: activeSorting,
    activeSorting: {
      sortBy: sortBy as TicketsRequestSortBy,
      sortOrder: sortOrder as SortOrder,
    },
    onSortingSelect: handleSortingSelect,
    onResetSorting: handleSortingRest,
  }
}
